"use client";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/pro-regular-svg-icons/faClock";
import { faShieldHalved } from "@fortawesome/pro-regular-svg-icons/faShieldHalved";
import {
  TYPICAL_CALL_DURATION_LABEL,
  TYPICAL_CALL_TITLE,
  NO_COMMITMENT_TITLE,
  NO_COMMITMENT_BODY,
} from "./successPageConstants";

const Row = ({
  icon,
  title,
  body,
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
}) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
    <Box
      sx={{
        flex: "0 0 auto",
        width: 24,
        height: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "primary.main",
        mt: 0.25,
      }}
    >
      {icon}
    </Box>
    <Box sx={{ textAlign: "left" }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600 }}>
        {body}
      </Typography>
    </Box>
  </Box>
);

export const CallDetailsCard = () => (
  <Box
    data-testid="success-call-details"
    sx={{
      width: "100%",
      border: 1,
      borderColor: "divider",
      borderRadius: 2,
      p: 2.5,
      display: "flex",
      flexDirection: "column",
      gap: 2,
    }}
  >
    <Typography
      variant="overline"
      color="text.secondary"
      sx={{ letterSpacing: 1, fontWeight: 700 }}
    >
      Call details
    </Typography>
    <Row
      icon={<FontAwesomeIcon icon={faClock} />}
      title={TYPICAL_CALL_TITLE}
      body={TYPICAL_CALL_DURATION_LABEL}
    />
    <Row
      icon={<FontAwesomeIcon icon={faShieldHalved} />}
      title={NO_COMMITMENT_TITLE}
      body={NO_COMMITMENT_BODY}
    />
  </Box>
);
